import React, { useContext } from 'react';
import styles from './style.css';
import { FlowContext } from '../../core/flow-engine';

const PhoneNumber = () => {
  const context = useContext(FlowContext);
  const { flowProps, appState } = context;
  const {
    store: { amount }
  } = appState;
  const { getContactText } = flowProps;

  return (
    <div id="footer-ph" className="footer-phone-number">
      <div>
        <div>
          <strong className="phone-header">
            Need Help? Call{' '}
            <a href={`tel:${getContactText(amount)}`}>
              {getContactText(amount)}
            </a>
          </strong>
        </div>
        <div>
          <div className="details">Financial Consultants are available</div>
          <div className="details">weekdays from 8 a.m. to 8 p.m. ET.</div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default PhoneNumber;
